import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { SpinnerIconComponent } from '../svg-icons/spinner-icon/spinner-icon.component';

@Component({
    selector: 'pos-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [SpinnerIconComponent]
})
export class SpinnerComponent implements OnInit {
  showSpinner: boolean;
  constructor(private _spinnerService: SpinnerService) {
  }

  ngOnInit() {
    this._spinnerService._spinnerVisibility.subscribe(showSpinner => {
      this.showSpinner = showSpinner;
    });
  }
}
